<template>
    <EonMultiSelect :name="name" :items="items" :emptyValue="emptyValue" v-model="internalValue"
                    item-label="label" item-value="value" :label="label" :width="width" :placeholder="placeholder"
                    :rules="rules"/>
</template>

<script>
    import EonMultiSelect from "@/components/form/EonMultiSelect";

    export default {
        name: "EonMultiSelectVoltageLevel",
        props: {
            type: {
                type: String,
            },
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            width: {
                type: String,
            },
            placeholder: {
                type: String,
                default: "",
            },
            rules: undefined,
            modelValue: null,
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [
                    {label: "nN", value: "LV"},
                    {label: "SN", value: "MV"},
                    {label: "WN", value: "HV"},
                ],
            };
        },

        components: {EonMultiSelect},
    };
</script>

<style scoped>
</style>
